import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const KlubStateFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "KlubStateFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.4536 12.1895C21.4025 11.3485 21.9979 10.1378 21.9979 8.79276C21.9979 6.25144 19.8687 4.18945 17.2409 4.18945C16.0858 4.18945 15.0255 4.58821 14.2007 5.25144L14.1965 5.25557C14.1628 5.28243 13.0499 6.25557 12 7.17499C10.9501 6.25557 9.83716 5.28243 9.80349 5.25557L9.79928 5.25144C8.97454 4.58821 7.91626 4.18945 6.7591 4.18945C4.13129 4.18945 2 6.25144 2 8.79483C2 10.1378 2.59752 11.3485 3.54639 12.1895C2.59752 13.0324 2 14.2411 2 15.5861C2 18.1295 4.13129 20.1895 6.7591 20.1895C7.91416 20.1895 8.97454 19.7907 9.79928 19.1275L9.80349 19.1233C9.83716 19.0965 10.9501 18.1233 12 17.2039C13.0499 18.1233 14.1628 19.0965 14.1965 19.1233L14.2007 19.1275C15.0255 19.7907 16.0837 20.1895 17.2409 20.1895C19.8687 20.1895 22 18.1275 22 15.5861C22 14.2411 21.4046 13.0324 20.4557 12.1895H20.4536ZM6.7591 6.60887C7.43657 6.60887 7.92258 6.8754 8.21502 7.10474C8.38123 7.24937 9.19966 7.96425 10.1485 8.79483C9.20177 9.62334 8.38123 10.3403 8.21502 10.4849C7.92047 10.7163 7.43446 10.9808 6.7591 10.9808C5.49253 10.9808 4.46371 9.99937 4.46371 8.79483C4.46371 7.59028 5.49464 6.60887 6.7591 6.60887ZM8.21713 17.2762C7.92258 17.5076 7.43657 17.7721 6.7612 17.7721C5.49463 17.7721 4.46581 16.7907 4.46581 15.5861C4.46581 14.3816 5.49674 13.4002 6.7612 13.4002C7.43657 13.4002 7.92258 13.6667 8.21713 13.8961C8.38334 14.0407 9.20177 14.7556 10.1506 15.5861C9.20387 16.4147 8.38334 17.1316 8.21713 17.2762ZM9.9697 12.1895C10.3211 11.8837 11.1795 11.1316 12.0021 10.4126C12.9531 9.57995 13.8515 8.79276 13.8515 8.79276C14.8003 7.96425 15.6188 7.2473 15.785 7.10268C16.0795 6.87127 16.5655 6.60681 17.2409 6.60681C18.5075 6.60681 19.5363 7.58821 19.5363 8.79276C19.5363 9.9973 18.5054 10.9787 17.2409 10.9787C16.0858 10.9787 15.0255 11.3775 14.2007 12.0407L14.1965 12.0448C14.1902 12.051 14.0324 12.1874 14.0324 12.1874C14.0324 12.1874 12.8226 13.2452 12 13.9642C11.1795 13.2452 10.3211 12.4952 9.9676 12.1874L9.9697 12.1895ZM17.2409 17.7721C16.5655 17.7721 16.0795 17.5056 15.785 17.2762C15.6188 17.1316 14.8003 16.4167 13.8515 15.5861C14.7982 14.7576 15.6188 14.0407 15.785 13.8961C16.0795 13.6647 16.5655 13.4002 17.2409 13.4002C18.5075 13.4002 19.5363 14.3816 19.5363 15.5861C19.5363 16.7907 18.5054 17.7721 17.2409 17.7721Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default KlubStateFalseIcon;
